export enum DownloadType {
  Full = 'full',
  PreviousFull = 'previous full',
  Incremental = 'incremental',
  PreviousIncremental = 'previous incremental',
}
